import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";

export const GET_IS_QA_REVIEW_ENABLED = "GET_IS_QA_REVIEW_ENABLED";

export const service = async () => {
  const options: object = {
    url: `/Api/Admin/IsQaReviewEnabled`,
    method: "GET",
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_IS_QA_REVIEW_ENABLED, service, mock);
